// https://github.com/n3r4zzurr0/range-slider-input

import ReactRangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import './RangeSlider.css';

const RangeSlider = ({ min = 0, max = 100, step, value, values, onChange, onInput, onDragEnd, ...props }) => {
  // Handle both 'value' (array) and 'values' (object with min/max) props
  let sliderValue = value;
  const usingValuesObject = values && typeof values === 'object' && 'min' in values && 'max' in values;
  
  if (usingValuesObject) {
    sliderValue = [values.min, values.max];
  }
  
  // Default value if neither provided (check for undefined/null, not falsy values like [0, 0])
  if (sliderValue === undefined || sliderValue === null) {
    sliderValue = [min, max];
  }
  
  // Handle both 'onChange' and 'onInput' props - react-range-slider-input uses 'onInput'
  const handleInput = (newValue) => {
    if (onInput) {
      onInput(newValue);
    }
    if (onChange) {
      // If onChange expects an object format (values prop was used), convert it
      if (usingValuesObject) {
        onChange({ min: newValue[0], max: newValue[1] });
      } else {
        onChange(newValue);
      }
    }
  };

  // Handle drag end event - react-range-slider-input may pass value as parameter
  const handleThumbDragEnd = (value) => {
    if (onDragEnd) {
      // If value is passed by the library, use it; otherwise use current sliderValue
      const currentValue = value || sliderValue;
      if (usingValuesObject && Array.isArray(currentValue)) {
        onDragEnd({ min: currentValue[0], max: currentValue[1] });
      } else if (usingValuesObject) {
        // If it's already an object, pass it through
        onDragEnd(currentValue);
      } else {
        onDragEnd(currentValue);
      }
    }
  };

  return (
    <div className="range-slider-container">
      <ReactRangeSlider 
        min={min} 
        max={max} 
        step={step} 
        value={sliderValue} 
        onInput={handleInput}
        onThumbDragEnd={handleThumbDragEnd}
        {...props}
      />
    </div>
  );
};

export default RangeSlider;